'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _listEditor = require('../../list-editor');

var _listEditor2 = _interopRequireDefault(_listEditor);

var _listTypeSelector = require('../../list-type-selector');

var _listTypeSelector2 = _interopRequireDefault(_listTypeSelector);

require('../styles/ListForm.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListForm = exports.ListForm = function (_BcReactComponent) {
  _inherits(ListForm, _BcReactComponent);

  function ListForm(props) {
    _classCallCheck(this, ListForm);

    var _this = _possibleConstructorReturn(this, (ListForm.__proto__ || Object.getPrototypeOf(ListForm)).call(this, props));

    _this.bindAll('renderEditor');
    return _this;
  }

  _createClass(ListForm, [{
    key: 'focusOnAddToList',
    value: function focusOnAddToList() {
      if (this._listEditor) {
        this._listEditor.getWrappedInstance().focusOnAddToList();
      }
    }
  }, {
    key: 'renderEditor',
    value: function renderEditor() {
      var _this2 = this;

      if (!this.props.list.get('listType')) {
        return _react2.default.createElement(_listTypeSelector2.default, {
          adminListTypes: this.props.adminListTypes,
          listTypes: this.props.listTypes,
          handleListTypeClicked: this.props.handleListTypeClicked });
      }

      return _react2.default.createElement(_listEditor2.default, {
        ref: function ref(el) {
          return _this2._listEditor = el;
        },
        list: this.props.list,
        items: this.props.listItems,
        listTypes: this.props.listTypes,
        selectableListTypes: this.props.selectableListTypes,
        listScopes: this.props.listScopes,
        listLocales: this.props.listLocales,
        listLanguages: this.props.listLanguages,
        searchParams: this.props.searchParams,
        searchResults: this.props.searchResults,
        webItem: this.props.webItem,
        listHasUnsavedChanges: this.props.listHasUnsavedChanges,
        savingDraft: this.props.savingDraft,
        publishing: this.props.publishing,
        failedToSave: this.props.failedToSave,
        editingAnchorBib: this.props.editingAnchorBib,
        listPreviewURL: this.props.listPreviewURL,
        addToListOpen: this.props.addToListOpen,
        showAddToList: this.props.showAddToList,
        messages: this.props.messages,
        allowFreeText: this.props.allowFreeText,
        listNameExamples: this.props.listNameExamples,
        keepSearchResultsOpen: this.props.keepSearchResultsOpen,
        addItemsToTop: this.props.addItemsToTop,
        handleEditAnchorBib: this.props.handleEditAnchorBib,
        handleListPropertyChange: this.props.handleListPropertyChange,
        handleFormSubmit: this.props.handleFormSubmit,
        handleSearch: this.props.handleSearch,
        handleAddBib: this.props.handleAddBib,
        handleAddWebItem: this.props.handleAddWebItem,
        handleRemoveItem: this.props.handleRemoveItem,
        handleItemPropertyChange: this.props.handleItemPropertyChange,
        handleOpenAddToList: this.props.handleOpenAddToList,
        handleCloseAddToList: this.props.handleCloseAddToList,
        getNextPageSearchResults: this.props.getNextPageSearchResults,
        setSearchParameter: this.props.setSearchParameter,
        handleSearchParameterChange: this.props.handleSearchParameterChange,
        handleClearSearch: this.props.handleClearSearch,
        handleWebItemPropertyChange: this.props.handleWebItemPropertyChange,
        handleItemMovedUp: this.props.handleItemMovedUp,
        handleItemMovedDown: this.props.handleItemMovedDown,
        handleAddItemsMoved: this.props.handleAddItemsMoved,
        jacketCoverImgSrc: this.props.jacketCoverImgSrc,
        handleGenerateJacketCover: this.props.handleGenerateJacketCover,
        handleItemDragged: this.props.handleItemDragged,
        handleAnchorBibSelected: this.props.handleAnchorBibSelected,
        handleBackButtonClick: this.props.handleBackButtonClick,
        getOffsetForStickyToolbar: this.props.getOffsetForStickyToolbar,
        handleAddItemsToTopChange: this.props.handleAddItemsToTopChange,
        handleWebURLSelected: this.props.handleWebURLSelected,
        availabilityDetailActions: this.props.availabilityDetailActions,
        showPublishOverlay: this.props.showPublishOverlay,
        handlePublishOverlayOpen: this.props.handlePublishOverlayOpen,
        handlePublishOverlayClose: this.props.handlePublishOverlayClose });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'cp-list-form',
          'data-test-id': 'user-list-editor',
          'data-test-saving': this.props.savingDraft || this.props.publishing ? 'true' : 'false' },
        this.renderEditor()
      );
    }
  }]);

  return ListForm;
}(_baseBcReactComponent2.default);

ListForm.propTypes = {
  adminListTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  listTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  selectableListTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  listScopes: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  listLanguages: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  listLocales: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  list: _bcPropTypes.listShape,
  listItems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchParams: _reactImmutableProptypes2.default.map,
  webItem: _reactImmutableProptypes2.default.map.isRequired,
  jacketCoverImgSrc: _react.PropTypes.shape({
    localUrl: _react.PropTypes.string,
    largeCover: _react.PropTypes.string,
    mediumCover: _react.PropTypes.string,
    smallCover: _react.PropTypes.string,
    type: _react.PropTypes.string
  }),
  jacketCoverIsLoading: _react.PropTypes.bool,
  listHasUnsavedChanges: _react.PropTypes.bool.isRequired,
  savingDraft: _react.PropTypes.bool.isRequired,
  publishing: _react.PropTypes.bool.isRequired,
  failedToSave: _react.PropTypes.bool.isRequired,
  editingAnchorBib: _react.PropTypes.bool.isRequired,
  listPreviewURL: _react.PropTypes.string,
  addToListOpen: _react.PropTypes.bool,
  showAddToList: _react.PropTypes.bool,
  messages: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.map),
  handleEditAnchorBib: _react.PropTypes.func.isRequired,
  handleListTypeClicked: _react.PropTypes.func.isRequired,
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  handleSearchParameterChange: _react.PropTypes.func.isRequired,
  handleSearch: _react.PropTypes.func.isRequired,
  handleFormSubmit: _react.PropTypes.func.isRequired,
  handleAddBib: _react.PropTypes.func.isRequired,
  handleAddWebItem: _react.PropTypes.func.isRequired,
  handleRemoveItem: _react.PropTypes.func.isRequired,
  handleItemPropertyChange: _react.PropTypes.func.isRequired,
  getNextPageSearchResults: _react.PropTypes.func.isRequired,
  handleClearSearch: _react.PropTypes.func.isRequired,
  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
  handleGenerateJacketCover: _react.PropTypes.func,
  handleItemDragged: _react.PropTypes.func.isRequired,
  handleAnchorBibSelected: _react.PropTypes.func.isRequired,
  handleBackButtonClick: _react.PropTypes.func.isRequired,
  handleOpenAddToList: _react.PropTypes.func.isRequired,
  handleCloseAddToList: _react.PropTypes.func.isRequired,
  handleAddItemsToTopChange: _react.PropTypes.func.isRequired,
  handleAddItemsMoved: _react.PropTypes.func.isRequired,
  handleItemMovedUp: _react.PropTypes.func.isRequired,
  handleItemMovedDown: _react.PropTypes.func.isRequired,
  handleWebURLSelected: _react.PropTypes.func.isRequired,
  getOffsetForStickyToolbar: _react.PropTypes.func.isRequired,
  allowFreeText: _react.PropTypes.bool.isRequired,
  listNameExamples: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  keepSearchResultsOpen: _react2.default.PropTypes.bool,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
  addItemsToTop: _react.PropTypes.bool,
  showPublishOverlay: _react.PropTypes.bool,
  handlePublishOverlayOpen: _react.PropTypes.func.isRequired,
  handlePublishOverlayClose: _react.PropTypes.func.isRequired
};

exports.default = ListForm;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-form/components/ListForm.component.js
// module id = 1307
// module chunks = 0